declare const Carousel: any;
declare const Thumbs: any;
declare const tippy: any;

namespace gotoAndPlay {

    $(function() {
        const container: HTMLElement = document.querySelector('.variation-slider__carousel');
        const choiceButtons: NodeListOf<HTMLElement> = document.querySelectorAll('.variation-slider__choice');
        let carouselInstance: any;

        if (container) {
            carouselInstance = Carousel(container, {
                infinite: true,
                center: true,
                slidesPerPage: 1,
                navigation: false,
                Thumbs: {
                    type: 'classic'
                }
            }, { Thumbs }).init();
        }

        if (choiceButtons.length > 0) {
            choiceButtons.forEach((button: HTMLElement) => {
                const tooltipText: string = button.getAttribute('data-name');

                if (tooltipText) {
                    tippy(button as HTMLElement, {
                        content: tooltipText,
                        placement: 'top',
                    });
                }
            });
        }

        $('body').on('click', '.variation-slider__choice', function() {
            const currentChoiceTarget: JQuery = $(this);
            const newImageUrl: string = currentChoiceTarget.attr('data-image');
            const parentComponent: JQuery = currentChoiceTarget.parents('.variation-slider');
            const choicesButtons: JQuery = parentComponent.find('.variation-slider__choice');
            const choicesLabel: JQuery = parentComponent.find('.variation-slider__choices-label-color');

            if (newImageUrl) {
                const sliderImage: JQuery = parentComponent.find('.f-carousel__slide:first-of-type .variation-slider__image .image__img');
                const sliderImageLink: JQuery = parentComponent.find('.f-carousel__slide:first-of-type a[data-fancybox="variation-slider-gallery"]');
                const thumbnailImage: JQuery = parentComponent.find('.f-thumbs__slide:first-of-type img');

                sliderImage.attr('srcset', newImageUrl);
                sliderImageLink.attr('href', newImageUrl).attr('data-thumb', newImageUrl);
                thumbnailImage.attr('src', newImageUrl);

                carouselInstance.goTo(0);
            }

            choicesButtons.removeClass('variation-slider__choice--active');
            currentChoiceTarget.addClass('variation-slider__choice--active');

            choicesLabel.text(currentChoiceTarget.attr('data-name'));

            parentComponent.find('.f-thumbs__slide').removeClass('is-selected');
            parentComponent.find('.f-thumbs__slide:first-of-type').addClass('is-selected');
        });
    });
}
